import { Link, useRouterState } from '@tanstack/react-router'
import { LayoutDashboard, Users, BarChart3, Package, Bell, LogOut, Moon, Sun, User, Activity, Rocket, Wand2 } from 'lucide-react'
import { useMsal } from '@azure/msal-react'
import { useContext } from 'react'
import { ThemeContext } from '../App'

export default function Navigation({ user }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const { instance } = useMsal()
  const { dark, toggle } = useContext(ThemeContext)

  const isActive = (path) => pathname === path

  const handleLogout = () => instance.logoutRedirect()

  const userEmail = user?.username || user?.userPrincipalName || ''

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        Numberskills
      </div>

      <div className="nav-links">
        <Link to="/" className={isActive('/') ? 'nav-link active' : 'nav-link'}>
          <LayoutDashboard size={18} />
          Dashboard
        </Link>
        <Link to="/customers" className={isActive('/customers') ? 'nav-link active' : 'nav-link'}>
          <Users size={18} />
          Customers
        </Link>
        <Link to="/analytics" className={isActive('/analytics') ? 'nav-link active' : 'nav-link'}>
          <BarChart3 size={18} />
          Analytics
        </Link>
        <Link to="/inventory" className={isActive('/inventory') ? 'nav-link active' : 'nav-link'}>
          <Package size={18} />
          Inventory
        </Link>
        <Link to="/alerts" className={isActive('/alerts') ? 'nav-link active' : 'nav-link'}>
          <Bell size={18} />
          Alerts
        </Link>
        <Link to="/health" className={isActive('/health') ? 'nav-link active' : 'nav-link'}>
          <Activity size={18} />
          Health
        </Link>
        <Link to="/onboarding" className={isActive('/onboarding') ? 'nav-link active' : 'nav-link'}>
          <Rocket size={18} />
          Onboarding
        </Link>
        <Link to="/pipeline-injector" className={isActive('/pipeline-injector') ? 'nav-link active' : 'nav-link'}>
          <Wand2 size={18} />
          Pipeline
        </Link>
      </div>

      <div className="navbar-actions">
        <div className="user-display">
          <User size={16} />
          <span>{userEmail}</span>
        </div>
        <button
          onClick={toggle}
          className="icon-button"
          title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {dark ? <Sun size={16} /> : <Moon size={16} />}
        </button>
        <button onClick={handleLogout} className="navbar-logout">
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </nav>
  )
}
